export default function guest ({ next, store }){
   
   if(store.state.auth.token){
       return next({
           path: '/account/user/dashboard'
       });
   }

   return next()
}